import { configureStore } from "@reduxjs/toolkit";
import reducer from "./reducers/index";
import { enableBatching } from "redux-batched-actions";
import filtersMiddleware from "./middleware/filtersMiddleware";

const store = configureStore({
  reducer: enableBatching(reducer),
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat(filtersMiddleware),
});

export default store;
